import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './airtrafficsnow.json'; // The JSON you provided

const AirTrafficSnow = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Aviation English, weather disruptions, and travel vocabulary. B2 level grammar, reading, and speaking exercises."
            level="B2"
            title="Air Traffic Snow"
            image="/Images/airsnow.webp"
            seoTitle="Free English Lesson Plans: Air Traffic in Snow"
            seoDescription="Aviation English, weather disruptions, and travel vocabulary. B2 level grammar, reading, and speaking exercises."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default AirTrafficSnow;


